// Remove Some text in the Judge Me Review Text widget

(function () {
  function fixJudgeMeReviewText() {
    document.querySelectorAll('.jdgm-all-reviews-text__text').forEach(function (el) {
      const score = parseFloat(el.getAttribute('data-score'));

      if (!isNaN(score)) {
        const newText = score.toFixed(1) + ' out of 5 stars';

        if (el.textContent.trim() !== newText) {
          el.textContent = newText;
        }
      }
    });
  }

  // Run immediately
  fixJudgeMeReviewText();

  // Judge.me can render/re-render asynchronously
  const observer = new MutationObserver(function () {
    fixJudgeMeReviewText();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  // Shopify theme editor / section reload
  document.addEventListener('shopify:section:load', fixJudgeMeReviewText);
})();


// Seal Subscription - One-time purchase default for KALOS product only
(function () {
  const TARGET_HANDLE = 'kalos-energy-focus-melts';

  function setOneTimePurchase() {
    // Only target this specific product
    const product = document.querySelector(
      '[data-product-handle="' + TARGET_HANDLE + '"]'
    );

    if (!product) return false;

    // Find Seal widget only inside this product
    const widget = product.querySelector('.sealsubs-target-element');
    if (!widget) return false;

    // Get purchase-option radios
    const radios = widget.querySelectorAll(
      '.sls-purchase-options-container input.sls-option[type="radio"]'
    );

    if (!radios.length) return false;

    // Subscription radios have data-type="subscription".
    // The non-subscription radio is the one-time purchase option.
    const oneTimeRadio = Array.from(radios).find(function (radio) {
      return radio.getAttribute('data-type') !== 'subscription';
    });

    if (!oneTimeRadio) return false;

    // Trigger Seal's own click handling
    if (!oneTimeRadio.checked) {
      oneTimeRadio.click();
    }

    return true;
  }

  // Try immediately
  if (!setOneTimePurchase()) {
    // Seal can load asynchronously
    const observer = new MutationObserver(function () {
      if (setOneTimePurchase()) {
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Safety cleanup
    setTimeout(function () {
      observer.disconnect();
    }, 10000);
  }
})();


// Change Seal Subscription Behaviour Js 


document.addEventListener('click', function (e) {

  // Popup ke andar "Learn more" link ko normal work karne do
  if (e.target.closest('.sls-more-info-popup a')) {
    return;
  }

  // Subscription details par click
  const infoText = e.target.closest('.sls-more-info-text');

  if (!infoText) return;

  const container = infoText.closest('.sls-more-info-container');

  if (!container) return;

  // Subscription details ke original link ko open hone se roko
  e.preventDefault();
  e.stopPropagation();

  // Dusre open popups close karo
  document.querySelectorAll('.sls-more-info-container.is-open').forEach(function (item) {
    if (item !== container) {
      item.classList.remove('is-open');
    }
  });

  // Current popup toggle
  container.classList.toggle('is-open');
});


// Container ke bahar click karne par popup close
document.addEventListener('click', function (e) {

  if (!e.target.closest('.sls-more-info-container')) {
    document.querySelectorAll('.sls-more-info-container.is-open').forEach(function (item) {
      item.classList.remove('is-open');
    });
  }

});
